export default "__VITE_ASSET__jKgf4_Tv__"